module.exports = {"370126001":"许商街道","370126101":"殷巷镇","370126102":"怀仁镇","370126104":"龙桑寺镇","370126105":"郑路镇","370126106":"贾庄镇","370126107":"玉皇庙镇","370126108":"白桥镇","370126109":"孙集镇","370126110":"韩庙镇","370126204":"沙河乡","370126207":"张坊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370126.json
// module id = 1258
// module chunks = 0